import request from "@/utils/request";
export const getAwsMachines = (params) => request({
    url: "/cyberlab/all-instances",
    method: "get",
    params
});
//# sourceMappingURL=cyberlab.js.map